module.exports = __webpack_public_path__ + "static/media/Default_img.a36ecf55.jpg";